import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedOrder } from '../../../../../../selectors/tools';
import { loadCancellationsBasedOffSelectedOrder } from '../../../../../../actions/tools/DecisionTree/OrderActions';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { CustomHeaderContextProvider } from '../../Common/SearchHeader/CustomHeaderContext';
import SearchHeaderResultsText from '../../Common/SearchHeader/SearchHeaderResultsText/SearchHeaderResultsText';
import isEmpty from 'lodash/isEmpty';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { OrderItemsSettingsContextProvider } from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/OrderItemsSettingsContext';

const DTSelectOrderToDetectCancellationsNode = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);
  const isLoading = useSelector(selectSearchPageLoading);

  const handleNextButtonClick = () => {
    dispatch(loadCancellationsBasedOffSelectedOrder());
  };

  return (
    <OrderItemsSettingsContextProvider value={{ hideItemCheckbox: true }}>
      <CustomHeaderContextProvider value={<SearchHeaderResultsText />}>
        <DTOrderSearchView
          onNextButtonClick={handleNextButtonClick}
          isNextButtonActive={!isEmpty(selectedOrder) && !isLoading}
        />
      </CustomHeaderContextProvider>
    </OrderItemsSettingsContextProvider>
  );
};

export default DTSelectOrderToDetectCancellationsNode;
